module.exports = __webpack_public_path__ + "img/hqdt.05429a02.png";